const test = {
    baseUrl: '//router2.gamersky.com/@/community',
    appapi2V1Url: '//appapi2click.gamersky.com/v1',
    appapi2V5Url: '//appapi2click.gamersky.com/v5',
    iUrl: '//i.gamersky.com',
}
const prod = {
    baseUrl: '//router.gamersky.com/@',
    appapi2V1Url: '//appapi2click.gamersky.com/v1',
    appapi2V5Url: '//appapi2click.gamersky.com/v5',
    iUrl: '//i.gamersky.com',
}
export default prod;
// export default prod;